import React from "react";
import { calculateDuration } from "../../services/function";
import { useStaffStore } from "../../stores/staff";

const WorkingHours = () => {
  const { weekHours, setWeekHours } = useStaffStore();
  const handleChangeHours = (
    id: number,
    field: string,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newValue = e.target.value;
    const updatedWeekHours = weekHours.map((day: any) => {
      if (day.day === id) {
        const updatedDay = { ...day, [field]: newValue };

        const morningDuration = calculateDuration(
          updatedDay.startAM,
          updatedDay.endAM
        );

        const afternoonDuration = calculateDuration(
          updatedDay.startPM,
          updatedDay.endPM
        );

        return { ...updatedDay, hours: morningDuration + afternoonDuration };
      }
      return day;
    });

    setWeekHours(updatedWeekHours);
  };

  return (
    <div className="bg-light-blue border-light-blue rounded-lg w-11/12 text-grey flex flex-col h-auto my-5 ">
      <div className="w-full flex flex-col justify-between items-center gap-4 my-2">
        {weekHours?.map((day) => (
          <div
            key={day.day}
            className="2xl:w-10/12 w-full grid grid-cols-6 px-4 py-2 gap-2"
          >
            <span className="col-start-1 col-end-2 mt-1">{day.name}</span>
            <div className="flex gap-2 col-start-2 col-end-4">
              <input
                type="time"
                name="startAM"
                value={day.startAM}
                step="60"
                lang="fr"
                onChange={(e) => handleChangeHours(day.day, "startAM", e)}
                className="border border-light-blue rounded-md px-2 py-1 bg-white"
              />
              <span className="pt-1">à</span>
              <input
                type="time"
                name="endAM"
                step="60"
                onChange={(e) => handleChangeHours(day.day, "endAM", e)}
                value={day.endAM}
                className="border border-light-blue rounded-md px-2 py-1 bg-white"
              />
            </div>
            <div className="flex gap-2 col-start-4 col-end-6">
              <input
                type="time"
                value={day.startPM}
                step="60"
                onChange={(e) => handleChangeHours(day.day, "startPM", e)}
                className="border border-light-blue rounded-md px-2 py-1 bg-white"
              />
              <span className="pt-1">à</span>
              <input
                type="time"
                step="60"
                value={day.endPM}
                onChange={(e) => handleChangeHours(day.day, "endPM", e)}
                className="border border-light-blue rounded-md px-2 py-1 bg-white"
              />
            </div>
            <div className="flex justify-start col-start-6 col-end-7">
              <p className="mr-4 mt-1">Total : </p>
              <p className="mt-1">{day?.hours}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkingHours;
